if (typeof Dropzone !== 'undefined') {
    Dropzone.autoDiscover = false;
} else {
    window.Dropzone = { autoDiscover: false };
}

$(function () {
    initDropzone();
});

window.initDropzone = function (container = document) {
    const $container = $(container);

    const $dropzones = $container.is('.dropzone')
        ? $container.filter(':not(.dz-clickable)')
        : $container.find('.dropzone:not(.dz-clickable)');

    $dropzones.each(function (index, el) {
        if (el.dataset.dropzoneInitialized === 'true') return;
        el.dataset.dropzoneInitialized = 'true';
        const parentForm = $(el).closest('form')[0];

        if (!parentForm) return;

        if (!parentForm.classList.contains('dropzone-form')) {
            throw new Error('The parent form of the dropzone component must contain the dropzone-form class');
        }

        const acceptedFiles = el.dataset.acceptFiles ?? 'image/*';
        const paramName = el.dataset.inputName;
        const multipleFiles = el.hasAttribute('data-multiple-files');
        const previewsContainer = el.querySelector('.previews');
        const maxFilesize = el.dataset.maxFilesize ?? 2;
        const message = el.dataset.message ?? (multipleFiles ? 'Clique ou arraste e solte os novos arquivos aqui' : 'Clique ou arraste o arquivo aqui');

        const fileURL = el.dataset.fileUrl;
        const fileSize = el.dataset.fileSize;
        const fileName = el.dataset.fileName;

        let isReplacing = false;

        if (multipleFiles && (fileURL || fileSize || fileName)) {
            console.warn('A opção "multiplesFiles" é incompatível com as opções "fileURL", "fileSize" e "fileName". As mesmas serão ignoradas.');
        }

        const previewElSrc = parentForm.querySelector(`[data-input-preview="${paramName}"]`);

        new Dropzone(el, {
            previewTemplate: $(el).find('template').html(),
            url: parentForm.action,
            maxFilesize,
            maxFiles: multipleFiles ? null : 1,
            acceptedFiles,
            addRemoveLinks: false,
            autoProcessQueue: false,
            previewsContainer,
            paramName,
            createImageThumbnails: !previewElSrc,
            thumbnailWidth: null,
            thumbnailHeight: null,
            thumbnailMethod: 'contain',
            hiddenInputContainer: parentForm,
            dictDefaultMessage: message,
            dictFileTooBig: 'O arquivo é muito grande ({{filesize}}MB). Tamanho máximo suportado: {{maxFilesize}}MB.',
            dictInvalidFileType: "Tipo de arquivo não suportado.",
            dictRemoveFile: 'Remover arquivo',
            maxfilesexceeded: function (file) {
                isReplacing = true;
                this.removeAllFiles();
                isReplacing = false;
                this.addFile(file);
            },
            init: function () {
                this.on("addedfile", file => {
                    this.element.querySelector('input.fake-input')?.remove();
                    parentForm.querySelector(`[name^=remover_${paramName}]`)?.remove();

                    if (previewElSrc) {
                        const src = file.isMock ? file.url : URL.createObjectURL(file);
                        const fileType = file.type || '';

                        if (/^video/.test(fileType)) {
                            previewElSrc.innerHTML = `
                                <video controls class="max-h-72">
                                    <source src="${src}">
                                    Seu navegador não suporta vídeos HTML5.
                                </video>
                            `;
                        } else {
                            let classes = '';

                            if (/^image/.test(fileType)) {
                                classes = 'max-w-full h-auto max-h-72';
                            }

                            if (/pdf$/.test(fileType)) {
                                classes = 'w-full h-96';
                            }

                            previewElSrc.innerHTML = `
                                <object data="${src}" type="${fileType}" class="flex flex-col items-center justify-center py-4 ${classes}">
                                    <i class="far fa-eye-slash fa-10x text-zinc-400"></i>
                                    <p class="text-zinc-400">Não foi possível realizar o preview para este tipo de arquivo!</p>
                                </object>
                            `;
                        }
                    }
                });

                this.on('removedfile', _ => {
                    if (fileURL && !isReplacing) {
                        parentForm.insertAdjacentHTML('beforeend', `<input type="hidden" name="remover_${paramName}" value="true">`);
                    }
                    previewElSrc && (previewElSrc.innerHTML = '');
                });

                if (fileURL) {
                    const ext = fileURL.split('.').pop().split('?')[0].toLowerCase();
                    let mimeType = 'image/jpeg';

                    if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext)) {
                        mimeType = `image/${ext === 'jpg' ? 'jpeg' : ext}`;
                    } else if (['mp4', 'webm', 'ogg'].includes(ext)) {
                        mimeType = `video/${ext}`;
                    } else if (ext === 'pdf') {
                        mimeType = 'application/pdf';
                    }

                    let mockFile = {
                        name: fileName ?? 'Imagem cadastrada',
                        size: fileSize ?? 0,
                        type: mimeType,
                        isMock: true,
                        url: fileURL
                    };

                    this.displayExistingFile(mockFile, fileURL, null, '', false);
                }
            }
        });
    });

    const $forms = $container.is('.dropzone-form')
        ? $container
        : $container.find('.dropzone-form');

    $forms.off('submit').on('submit', event => {
        event.preventDefault();
        event.stopPropagation();

        const form = event.target;
        const formData = new FormData(form);
        const dropzones = getAllDropzonesInstances(form);

        dropzones.forEach((dropzone, index) => {
            if (dropzone.element.hasAttribute('data-required')
                && !dropzone.files.length
                && !dropzone.previewsContainer.childElementCount
                && dropzone.element.checkVisibility()) {

                const input = document.createElement('input');
                input.type = 'text';
                input.name = `fake-input-${index}`;
                input.required = true;
                input.classList.add('fake-input');
                input.style.position = 'absolute';
                input.style.top = '50%';
                input.style.left = '0';
                input.style.right = '0';
                input.style.opacity = '0';
                input.autocomplete = 'off';

                if (dropzone.options.maxFiles === 1) {
                    input.setCustomValidity('Selecione um arquivo!');
                } else {
                    input.setCustomValidity('Selecione um ou mais arquivos!');
                }

                dropzone.element.appendChild(input);
            }

            addDropzoneFilesToFormData(dropzone, formData);
        });

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const methodInput = form.querySelector('input[name="_method"]');
        if (methodInput) {
            formData.set('_method', methodInput.value);
        }

        axios.post(form.action, formData)
            .then(response => {
                const { data } = response;

                if (!data.success) {
                    throw new Error(data.message);
                }

                if (data.redirect) {
                    window.location.replace(data.redirectTo ?? window.location.href);
                    return;
                }

                $(form).find(':reset').html('<i class="fa fa-times"></i> Fechar');
                showNotification(data.message ?? 'Sua solicitação foi processada com sucesso!');

                window.ajaxSuccessHandler && window.ajaxSuccessHandler();
            })
            .catch(error => {
                if (typeof Spinner !== 'undefined') Spinner.hide();

                $(form).find('.has-error').removeClass('has-error');
                $(form).find('.text-red-500.error-msg').remove();

                if (error.response && error.response.status === 422) {
                    const errors = error.response.data.errors;

                    if (errors) {
                        let primeiraMensagem = '';

                        Object.keys(errors).forEach(field => {
                            const messageList = errors[field];
                            const messageText = messageList[0];

                            if (!primeiraMensagem) {
                                primeiraMensagem = messageText;
                            }

                            const $input = $(form).find(`[name="${field}"], [name="${field}[]"]`);

                            if ($input.length) {
                                $input.closest('.flex, .form-group, div').addClass('has-error');

                                $input.after(`<small class="text-red-500 error-msg font-semibold mt-1">${messageText}</small>`);
                            } else {
                                const $dropzoneContainer = $(form).find(`[data-input-name="${field}"]`).closest('div');
                                $dropzoneContainer.addClass('has-error');
                                $dropzoneContainer.after(`<small class="text-red-500 error-msg font-semibold mt-1">${messageText}</small>`);
                            }
                        });

                        showNotification(primeiraMensagem, { type: 'error' });
                        return;
                    }
                }
                const genericMessage = error.response?.data?.message ?? error.message ?? 'Ocorreu um erro ao processar a requisição!';
                showNotification(genericMessage, { type: 'error' });
            });
    });
};

function getAllDropzonesInstances(form) {
    if (!form) throw new Error('It is necessary to inform the reference form');
    return Array.from(form.querySelectorAll('.dropzone.dz-clickable')).map(dropzone => dropzone.dropzone);
}

function addDropzoneFilesToFormData(dropzone, formData) {
    let { paramName, maxFiles } = dropzone.options;

    const realFiles = dropzone.files.filter(file => !file.isMock);

    realFiles.forEach((file, index) => {
        if (maxFiles === 1) {
            formData.set(paramName, file);
            return;
        }
        formData.append(`${paramName}[${index}]`, file);
    });
}
